import { ChevronDownThinIcon } from 'xyz-icon-set-react/dist/icons/ChevronDownThinIcon';
import styles from './ScrollHint.module.css';

export const ScrollHint = () => (
  <div className={styles.hint} aria-hidden={true}>
    <span className={styles.bob}>
      <ChevronDownThinIcon />
    </span>
  </div>
);
